import { SVGFC } from '@repo/toolkit/types'

const SolidUpArrowIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0002 7.50097C10.142 7.50169 10.2818 7.53396 10.4096 7.59545C10.5374 7.65693 10.6499 7.74609 10.7389 7.85646L13.0773 10.6892C13.214 10.8598 13.3 11.0653 13.3255 11.2823C13.351 11.4993 13.3151 11.7192 13.2218 11.9168C13.1461 12.0885 13.0225 12.2348 12.8659 12.3382C12.7093 12.4417 12.5263 12.4978 12.3386 12.5L7.66173 12.5C7.47407 12.4978 7.291 12.4417 7.1344 12.3382C6.97779 12.2348 6.85426 12.0885 6.77857 11.9168C6.68523 11.7192 6.64929 11.4993 6.67482 11.2823C6.70035 11.0653 6.78634 10.8598 6.92298 10.6892L9.26142 7.85646C9.35045 7.74609 9.46294 7.65693 9.59072 7.59545C9.7185 7.53396 9.85836 7.50169 10.0002 7.50097Z"
        fill={color}
      />
    </svg>
  )
}

export default SolidUpArrowIcon
